// const queryString = require('query-string')
import axios from 'axios'

export default {
  updateCompany ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      let phone = state.company.phone.replace(/\D/g, '')
      state.company.zipCode = state.company.zipCode.replace(/\D/g, '')
      let areaCode = phone.substring(0, 2)
      let phoneNumber = phone.substring(2, phone.length)
      let form = new FormData()
      form.append('fantasia', state.company.tradingName)
      form.append('DDD', areaCode)
      form.append('Telefone', phoneNumber)
      form.append('Categorias', state.company.categories)
      form.append('Endereco', state.company.address)
      form.append('Nro', state.company.addressNumber)
      form.append('Cep', state.company.zipCode)
      form.append('Bairro', state.company.neighborhood)
      form.append('Cidade', state.company.city)
      form.append('UF', state.company.state)
      // form.append('DocId', '')
      // form.append('Contato', '')
      form.append('Url', state.company.site)
      form.append('Complemento', state.company.complement)
      form.append('DescricaoNegocio', state.company.description)
      form.append('Logo', state.company.logo)

      form.append('NeedSchedule', state.company.needSchedule)
      form.append('CustomTime', state.company.customTime)

      form.append('WeekDayStart', state.company.weekDayStart)
      form.append('WeekDayEnd', state.company.weekDayEnd)
      form.append('WeekDayInterval', state.company.weekDayInterval)
      form.append('WeekDayCapacity', state.company.weekDayCapacity)

      form.append('SundayStart', state.company.sundayStart)
      form.append('SundayEnd', state.company.sundayEnd)
      form.append('SundayInterval', state.company.sundayInterval)
      form.append('SundayCapacity', state.company.sundayCapacity)

      form.append('MondayStart', state.company.mondayStart)
      form.append('MondayEnd', state.company.mondayEnd)
      form.append('MondayInterval', state.company.mondayInterval)
      form.append('MondayCapacity', state.company.mondayCapacity)

      form.append('TuesdayStart', state.company.tuesdayStart)
      form.append('TuesdayEnd', state.company.tuesdayEnd)
      form.append('TuesdayInterval', state.company.tuesdayInterval)
      form.append('TuesdayCapacity', state.company.tuesdayCapacity)

      form.append('WednesdayStart', state.company.wednesdayStart)
      form.append('WednesdayEnd', state.company.wednesdayEnd)
      form.append('WednesdayInterval', state.company.wednesdayInterval)
      form.append('WednesdayCapacity', state.company.wednesdayCapacity)

      form.append('ThursdayStart', state.company.thursdayStart)
      form.append('ThursdayEnd', state.company.thursdayEnd)
      form.append('ThursdayInterval', state.company.thursdayInterval)
      form.append('ThursdayCapacity', state.company.thursdayCapacity)

      form.append('FridayStart', state.company.fridayStart)
      form.append('FridayEnd', state.company.fridayEnd)
      form.append('FridayInterval', state.company.fridayInterval)
      form.append('FridayCapacity', state.company.fridayCapacity)

      form.append('SaturdayStart', state.company.saturdayStart)
      form.append('SaturdayEnd', state.company.saturdayEnd)
      form.append('SaturdayInterval', state.company.saturdayInterval)
      form.append('SaturdayCapacity', state.company.saturdayCapacity)

      commit('loadingCompany', true)
      axios({
        method: 'post',
        url: process.url + 'Cadastro/Salvar',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      })
      .then((response) => {
        commit('loadingCompany', false)
        let data = response.data
        if (data.preErros.length > 0) {
          commit('toastrApiError', data.preErros)
          reject(data)
          // TODO: Integrar a api com erros[]
        } else {
          commit('toastr', {
            color: 'success',
            texto: 'Dados alterados'
          })
          // clear input and load http logo
          if (data.resultado.logo !== '') {
            commit('updateLogo', data.resultado.logo)
          }
          commit('updateStatus', data.resultado.code)
          commit('unshelfLogo')
          // TODO: se status for 60% mandar uma mensagem de esperando omologação commit('homologaçõa')
          resolve()
        }
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('loadingCompany', false)
        commit('toastrAxiosError', error)
        // reject(error)
      })
    })
  },
  zipCodeSearch ({state, commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('loadingZipCode', true)
      axios.get('https://viacep.com.br/ws/' + state.company.zipCode + '/json/').then((response) => {
        commit('loadingZipCode', false)
        if (response.erro) {
          commit('toastr', {
            color: 'error',
            texto: 'CEP não encontrado'
          })
        } else {
          commit('updateAddress', response.data.logradouro)
          commit('updateNeighborhood', response.data.bairro)
          commit('updateState', response.data.uf)
          commit('updateCity', response.data.localidade)
        }
      })
      .catch((error) => {
        console.log(error)
        commit('toastr', {
          color: 'error',
          texto: 'CEP não encontrado'
        })
        commit('loadingZipCode', false)
      })
    })
  },
  getCompanyData ({state, commit}) {
    return new Promise((resolve, reject) => {
      window.http.get('Fornecedor/GetDetalhe')
      .then((response) => {
        resolve()
        commit('loadCompany', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
      })
    })
  },
  shelfLogo ({state, commit}, value) {
    let reader = new FileReader()
    commit('updateLogo', value)
    reader.onload = (e) => {
      state.logoNotSent = e.target.result
    }
    reader.readAsDataURL(value)
  },
  getEvaluations ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Fornecedor/Evaluations?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadEvaluations', response.data.resultado)
      })
      .catch((error) => {
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getUsers ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Fornecedor/GetUsuarios?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadUsers', response.data.resultado)
      })
      .catch((error) => {
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  selectUser ({state, commit}, id) {
    if (id === 0) {
      commit('newUser')
      commit('toggleUserModal', true)
      return
    } else {
      commit('toggleLoadingMounted', true)
      return new Promise((resolve, reject) => {
        window.http.get('Fornecedor/GetUsuario?id=' + id)
        .then((response) => {
          commit('toggleLoadingMounted', false)
          commit('selectUser', response.data.resultado)
          commit('toggleUserModal', true)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  updateUser ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      // window.http.post('Itens/Salvar', queryString.stringify(JSON.stringify(state.selectedItem)))
      let form = new FormData()
      for (var key in state.selectedUser) {
        if (typeof state.selectedUser[key] === 'object') {
          form.append(key, JSON.stringify(state.selectedUser[key]))
        } else {
          form.append(key, state.selectedUser[key])
        }
      }
      commit('toggleLoadingItemAction', true)
      axios({
        method: 'post',
        url: process.url + 'Fornecedor/SalvarUsuario',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: form
      })
      .then((response) => {
        commit('toggleLoadingItemAction', false)
        let data = response.data
        if (data.preErros.length > 0) {
          // commit('toastrApiError', data.preErros)
          reject(data)
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          })
          // TODO: Integrar a api com erros[]
        } else {
          if (data.preErros.length > 0) {
            commit('toastr', {
              color: 'error',
              texto: data.preErros[0]
            })
          } else {
            if (state.selectedUser.id === 0) {
              commit('appendNewUser', data.resultado)
              commit('toggleUserModal', false)
              commit('toastr', {
                color: 'success',
                texto: 'Usuário cadastrado com sucesso'
              })
            } else {
              commit('updateRegisteredUsers', data.resultado)
              commit('toastr', {
                color: 'success',
                texto: 'Usuário atualizado com sucesso'
              })
              commit('toggleUserModal', false)
            }
          }
          resolve()
        }
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingItemAction', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  salvarResposta ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      let form = new FormData()
      form.append('idNota', state.selectedAvaliacao.id)
      form.append('resposta', state.selectedAvaliacao.resposta)
      commit('toggleLoadingItemAction', true)
      axios({
        method: 'post',
        url: process.url + 'Fornecedor/SalvarRespostaAvaliacao',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: form
      })
      .then((response) => {
        commit('toggleLoadingItemAction', false)
        let data = response.data
        if (data.preErros.length > 0) {
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          })
        } else {
          commit('appendNewItem', data.resultado)
          commit('toggleItemModal', false)
          commit('toastr', {
            color: 'success',
            texto: 'Resposta cadastrada com sucesso'
          })
        }
        resolve()
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingItemAction', false)
        commit('toastrAxiosError', error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/empresa/actions.js